interface CallToActionSectionProps {
  onStartConversation: () => void;
}

export function CallToActionSection({ onStartConversation }: CallToActionSectionProps) {
  return (
    <div className="text-center">
      <p 
        className="text-xl sm:text-2xl mb-6 sm:mb-8"
        style={{ 
          fontFamily: 'Playfair Display, serif',
          fontStyle: 'italic',
          color: '#1D1D1D'
        }}
      >
        This is just the start. Let&apos;s make it truly yours!
      </p>

      <button
        onClick={onStartConversation}
        className="w-full sm:w-auto mx-auto px-8 sm:px-12 py-4 sm:py-5 rounded-lg mb-6 sm:mb-8 flex items-center justify-center gap-3 transition-all transform hover:scale-[1.02] shadow-lg hover:shadow-xl"
        style={{ 
          background: '#10333B',
          color: '#F6F4E5'
        }}
      >
        <span className="material-icons">phone</span>
        <span 
          className="text-sm sm:text-base font-bold uppercase tracking-wide"
          style={{ 
            fontFamily: 'Inter, sans-serif'
          }}
        >
          START CONVERSATION WITH PROFOUND
        </span>
      </button>

      {/* Info Icons */}
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-4 text-sm text-gray-600">
        <div className="flex items-center gap-2">
          <span className="material-icons text-base">schedule</span>
          <span style={{ fontFamily: 'Inter, sans-serif' }}>Takes ~15 minutes</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="material-icons text-base">lock</span>
          <span style={{ fontFamily: 'Inter, sans-serif' }}>Private and secure</span>
        </div>
      </div>

      {/* Disclaimer */}
      <p 
        className="text-xs sm:text-sm text-gray-500 max-w-2xl mx-auto"
        style={{ 
          fontFamily: 'Inter, sans-serif',
          lineHeight: '1.5'
        }}
      >
        This Conversation is Anonymous and we will never share your data with any third party platforms.
      </p>
    </div>
  );
}

